export default "__VITE_ASSET__Vt4p_inW__"